import axios from "axios";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Navigate } from "react-router-dom";

// Used by the Settings > Privacy Policy screen in the dashboard. Requires
// login since it's editing content, same pattern as getrestrictions().
export async function getprivacypolicy() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/getprivacypolicy`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function updateprivacypolicy(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/updateprivacypolicy`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Used by the login page. No auth header — nobody is logged in yet — same
// pattern as branchmaster() in services/login.js.
export async function getpublicprivacypolicy() {
  try {
    return await axios
      .get(`${baseUrl}/publicprivacypolicy`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        // Don't toast on the login page for this — a missing/blank policy
        // shouldn't get in the way of someone trying to sign in.
        console.log("Privacy policy fetch error:", error);
      });
  } catch (error) {
    console.log("Privacy policy fetch error:", error);
  }
}

function catcherror(error) {
  console.log(error);
  if (error.response.status === 401) {
    localStorage.clear();
    window.location.reload();
    <Navigate to={"/login"} />;
  } else if (error.response.status === 422) {
    Swal.fire({
      title:
        "There are few errors occured while inserting/updating the data to the database.",
      showCancelButton: false,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    });
  } else if (error.response.status === 0) {
    toast.error(error.message);
  } else if (error.response.status === 500) {
    toast.error(error.response.statusText);
  } else if (
    error.response.status !== 200 &&
    error.response.data.status === false &&
    error.response.data.code !== 200
  ) {
    toast.error(error.response.data.message);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    toast.error(error.message);
  }
}
